import {createI18n, LocaleMessages, NumberOptions, VueMessageType} from 'vue-i18n'
import {NumberFormats as IntlNumberFormats} from "@intlify/core-base";

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages(): { [x: string]: LocaleMessages<VueMessageType> } {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages: { [x: string]: LocaleMessages<VueMessageType> } = {} ;

    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key).default;
        }
    });

    return messages;
}

const numberFormats: IntlNumberFormats = {
    'da-DK': {
        currency: {
            style: 'currency', currency: 'DKK', notation: 'standard', maximumFractionDigits: 0
        },
        currencyDecimal: {
            style: 'currency', currency: 'DKK', notation: 'standard'
        }
    }
};

export default createI18n({
    locale: 'da-DK',
    messages: loadLocaleMessages(),
    numberFormats
});
